import ValueUtils from '../../../ts/utils/ValueUtils';
import { ITag } from '../../models/ITag';
import { ITagsProvider } from './ITagsProvider'

export class TagsProvider {
    private provider: ITagsProvider;
    
    public allTags: ITag[];
    public userTags: ITag[];
    
    private allTagsPromise: Promise<{allTags: ITag[], userTags: ITag[]}>;
    
    constructor(provider: ITagsProvider){
        this.provider = provider;
    }
    
    public getAllTags(): Promise<{allTags: ITag[], userTags: ITag[]}> {
        if(this.allTags != null && this.userTags != null) {
            return Promise.resolve({ allTags: this.allTags, userTags: this.userTags});
        }

        if(this.allTagsPromise != null) { return this.allTagsPromise; }

        this.allTagsPromise = this.provider.getAllTags();

        this.allTagsPromise.then(data => {
            this.allTags = data.allTags;
            this.userTags = data.userTags;

            this.markFollowedTags();
        }).catch(e => {
            this.allTagsPromise = null;
        });

        return this.allTagsPromise;
    }
       
    public followTag(tag: ITag): Promise<void> {
        const result = this.provider.followTag(tag);

        this.userTags.push(tag);
        this.markFollowedTags();
        result.catch(() => {
            ValueUtils.removeItemFromArray(this.userTags, tag);
            this.markFollowedTags();
        });

        return result;
    }
    
    public unfollowTag(tag: ITag): Promise<void> {
        const result = this.provider.unfollowTag(tag);

        ValueUtils.removeItemFromArray(this.userTags, this.userTags.find(it => it.id == tag.id));
        this.markFollowedTags();
        
        result.catch(() => {
            this.userTags.push(tag);
            this.markFollowedTags();
        });

        return result;
    }

    private markFollowedTags(){
        const userTagsMap = {};
        for(const tag of this.userTags) { 
            userTagsMap[tag.id] = true; 
            tag.isFollowed = true;
        }

        for(const tag of this.allTags){
            tag.isFollowed = !!userTagsMap[tag.id];
        }
    }
}